import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { AppProviders } from "@/app/providers";
import { AppRouter } from "@/app/router";
import "@/styles/globals.css";

/**
 * After a deploy, an open tab still references the previous build's hashed
 * chunks, which no longer exist. Vite fires this when a lazy import fails;
 * reload once to pick up the new build. The session flag stops a reload loop
 * if the chunk is genuinely broken (the router's error page takes over then).
 */
window.addEventListener("vite:preloadError", (event) => {
  try {
    if (sessionStorage.getItem("chunk-reloaded") === "1") {
      return;
    }
    sessionStorage.setItem("chunk-reloaded", "1");
  } catch {
    return;
  }
  event.preventDefault();
  window.location.reload();
});

// A page that stayed up for a while loaded fine, so allow the next deploy to reload it again.
window.setTimeout(() => {
  try {
    sessionStorage.removeItem("chunk-reloaded");
  } catch {
    // storage unavailable — nothing to clear
  }
}, 10_000);

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element #root not found");
}

createRoot(rootElement).render(
  <StrictMode>
    <AppProviders>
      <AppRouter />
    </AppProviders>
  </StrictMode>,
);
